import { Base } from "./Base";
import { ICountry, IServiceProvider, IServiceCatalog } from "./shared/types";
import { ServiceProvider } from "./ServiceProvider";
import { User } from "./User";

import i18n from "@/common/filters";

export class ServiceCatalog extends Base implements IServiceCatalog {
  HalloId: string; //system generated surrogate key.
  Code: string; //application defined key, define once and never changed
  Name: string; //display name, such as nickname or short name
  Catchword: string;  //a message or slogan for this provider
  Avatar: string;
  CoverImage: string;
  Region: ICountry;
  Email: string;
  Mobile: string;
  QRCode: string;
  Upline: ServiceCatalog; //required if this is a child of the Catalog
  Downlines: ServiceCatalog[]; //sub-catalogs

  Available: boolean = false;
  Manager: User;
  Acting?: User;

  showDownlines?: boolean = false;

  private _serviceProvider: ServiceProvider; //required if this is the root of Catalogs

  protected _basePropertyNames = [
    'HalloId', 'Code','Name', 'Catchword', 'Avatar', 'CoverImage', 
    'Region', 'Email', 'Mobile', 'QRCode'
  ];

  protected _propertyNames = [
    ...this._basePropertyNames,
    'Available', 'Manager', 'Url', 'ServiceProvider', 'Upline', 'Downlines'
  ]

  constructor(catalog?:IServiceCatalog) {
    super();
    if (catalog) {
      this.Properties = catalog;   
    }
  }
  
  get Properties() : IServiceCatalog {
    return <IServiceCatalog>this.getProperties();
  }
  
  set Properties(catalog:IServiceCatalog) {
    for (let p in catalog) {
      if (p=='ServiceProvider') {
        this._serviceProvider = new ServiceProvider(catalog[p]);
      } else if (p=='Manager') {
        this[p] = new User(catalog[p]);
      } else if (p=='Downlines') { //create child catalogs
        this.Downlines = catalog[p].map((sc:IServiceCatalog) => {
          let c = new ServiceCatalog(sc);
          c.Upline = this;
          return c;
        }, this);
      } else if (this._propertyNames.indexOf(p) != -1) {
        this[p] = catalog[p];
      }
    }
    if (this.Downlines) {
      this.Downlines.forEach((sc) => {
        sc.ServiceProvider = sc.ServiceProvider || this.ServiceProvider;
      }, this);
    }
  }

  set PropertiesFromStorage(catalog:any) {
    let lang = this.DeviceLanguage;
    catalog.code = catalog.code || catalog.code_pk;
    if (catalog.code && catalog.code!=this.Code) {
      this.Code = catalog.code;
    }
    catalog.name = catalog.name || catalog['name_' + lang];
    if (catalog.name && catalog.name!=this.Name) {
      this.Name = catalog.name;
    }
    if (catalog.available!=undefined) {
      catalog.available = (catalog.available==true || catalog.available=='true');
      if (catalog.available!=this.Available) {
        this.Available = catalog.available;
      }
    }
    if (catalog.category===null) {
      this.Upline = null;
    } else if (catalog.category) {
      this.Upline = new ServiceCatalog({
        Code: catalog.category_code,
        Name: catalog.category
      });
    }
    if (catalog.manager_id===null) { 
      this.Manager = null;
    } else if (catalog.manager_id) {
      this.Manager = new User({
        HalloId: catalog.manager_id,
        GivenName: catalog.manager_name,
        Surname: catalog.manager_surname,
        Position: {
          Code: catalog.manager_code
        }
      });
    }
    if (catalog.acting_id===null) {
      this.Acting = null;
    } else if (catalog.acting_id) {
      this.Acting = new User({
        HalloId: catalog.acting_id,
        GivenName: catalog.acting_name,
        Surname: catalog.acting_surname
      });
    }
  }

  set ServiceProvider(provider:IServiceProvider) {
    this._serviceProvider = new ServiceProvider(provider);
  }

  get ServiceProvider() : IServiceProvider {
    if (this._serviceProvider) {
      return this._serviceProvider.Properties;
    } else {
      let sc = this.Upline;
      if (sc) {
        while (sc.Upline) {
          sc = sc.Upline;
        }
        return sc.ServiceProvider;
      } else {
        return null;
      }
    }
  }

  get PersonInCharge() : string {
    let text:string;
    if (this.Manager && this.Manager.HalloId) {
      text = i18n.L('personInCharge') + ': ' + this.Manager.FullName;
      if (this.Acting && this.Acting) {
        text += '; ' + i18n.L('acting') + ': ' + this.Acting.FullName;
       }
    } else {
      text = i18n.L(['personInCharge',': ','notSet']);
    }
    return text;
  }

  private _selected:boolean = false;
  get Selected() : boolean {
      return this._selected;
  }

  set Selected(value:boolean) {
    this._selected = value;
  }

  get SelectedDownline() : ServiceCatalog {
    let selected:ServiceCatalog = null;
    if (this.Selected && this.Downlines && this.Downlines.length>0) {
      for (let i=0; i<this.Downlines.length; i++) {
        if (this.Downlines[i].Selected) {
          selected = this.Downlines[i];
          break;
        }
      }
    }
    return selected;
  }
}
